import {
  ActionBar,
  ActionBarProps,
  ChakraStack,
  DateFormat,
  FAIconName,
} from '@equip.health/ui';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import { DateTime } from 'luxon';

import useChatProviderOutOfOffice from '~/lib/hooks/chat/useChatProviderOutOfOffice';

interface ChatOutOfOfficeActionBarListProps {
  selectedChannel?: GroupChannel;
}

const ChatOutOfOfficeActionBarList = ({
  selectedChannel,
}: ChatOutOfOfficeActionBarListProps) => {
  const { isOutOfOfficeFetched, chatUserOOODetails } =
    useChatProviderOutOfOffice(selectedChannel?.members);

  if (!isOutOfOfficeFetched) {
    return null;
  }

  const chatActionBars: ActionBarProps[] = chatUserOOODetails?.map((om) => {
    const formattedStart = DateTime.fromISO(om.ooo.startDate).toFormat(
      DateFormat.shortMonthDayYear,
    );
    const formattedEnd = DateTime.fromISO(om.ooo.endDate).toFormat(
      DateFormat.shortMonthDayYear,
    );
    const oooText = `${om.nickname} is out of office from ${formattedStart} - ${formattedEnd}`;
    return {
      barIcon: FAIconName.calendarXmarkRegular,
      id: om.userId,
      text: oooText,
      variant: 'info',
    };
  });

  return (
    <>
      {chatActionBars.map((cabi) => {
        return (
          <ChakraStack key={`ooo-${cabi.id}`} padding="4px 0px" width="100%">
            <ActionBar
              barIcon={FAIconName.calendarXmarkRegular}
              id={`chat-action-bar-${cabi.variant}-${cabi.id}`}
              size="small"
              text={cabi.text}
              textPlacement="center"
              variant={cabi.variant}
            />
          </ChakraStack>
        );
      })}
    </>
  );
};

export default ChatOutOfOfficeActionBarList;
